export const dataLayerTag = (event) => {
  window.dataLayer.push(event);
}
